import React, { useEffect, useState } from 'react';
import CrudTable from '../../components/common/CrudTable';
import { groupAPI, trainerAPI, gymAPI } from '../../api/services';
import { FiX } from 'react-icons/fi';

const DAY_OPTIONS = [
  { label: 'Monday', value: 'MONDAY' },
  { label: 'Tuesday', value: 'TUESDAY' },
  { label: 'Wednesday', value: 'WEDNESDAY' },
  { label: 'Thursday', value: 'THURSDAY' },
  { label: 'Friday', value: 'FRIDAY' },
  { label: 'Saturday', value: 'SATURDAY' },
  { label: 'Sunday', value: 'SUNDAY' },
];

const GroupsAdmin = () => {
  const [trainers, setTrainers] = useState([]);
  const [showQuickAddTrainer, setShowQuickAddTrainer] = useState(false);
  const [quickTrainerForm, setQuickTrainerForm] = useState({ fullName: '', phone: '' });
  const [savingTrainer, setSavingTrainer] = useState(false);

  const [branches, setBranches] = useState([]);

  const loadTrainers = () => {
    trainerAPI.getAll()
      .then(res => setTrainers(res.data?.data || []))
      .catch(() => {});
  };

  const loadBranches = () => {
    gymAPI.getAll()
      .then(res => setBranches(res.data?.data || []))
      .catch(() => {});
  };

  useEffect(() => {
    loadTrainers();
    loadBranches();
  }, []);

  const handleQuickAddTrainer = async (e) => {
    e.preventDefault();
    setSavingTrainer(true);
    try {
      await trainerAPI.add(quickTrainerForm);
      loadTrainers();
      setShowQuickAddTrainer(false);
      setQuickTrainerForm({ fullName: '', phone: '' });
    } catch (err) {
      alert('Failed to add trainer');
    } finally {
      setSavingTrainer(false);
    }
  };

  const formatDays = (days) => {
    if (!days || days.length === 0) return '—';
    return days.map(d => d.substring(0, 3)).join(', ');
  };

  const COLUMNS = [
    { key: 'name', label: 'Group Name' },
    { key: 'description', label: 'Description' },
    {
      key: 'dayOfWeeks',
      label: 'Days',
      render: (item) => formatDays(item.dayOfWeeks),
    },
    {
      key: 'localTime',
      label: 'Time',
      render: (item) => item.localTime || '—',
    },
    { 
      key: 'gymDto', 
      label: 'Branch', 
      render: (item) => item.gymDto?.name || 'No Branch' 
    },
    { 
      key: 'trainerDto', 
      label: 'Trainer', 
      render: (item) => item.trainerDto?.fullName || 'No Trainer' 
    },
  ];

  const FORM_FIELDS = [
    { name: 'name', label: 'Group Name', placeholder: 'Elite Boxing Group' },
    { name: 'description', label: 'Description', placeholder: 'Advanced training for professionals' },
    {
      name: 'dayOfWeeks',
      label: 'Training Days',
      type: 'multiselect',
      options: DAY_OPTIONS,
    },
    {
      name: 'localTime',
      label: 'Training Time',
      type: 'time',
      placeholder: '09:00',
    },
    { 
      name: 'gymId', 
      label: 'Assign Branch', 
      type: 'select', 
      options: branches.map(b => ({ label: b.name, value: b.id })),
    },
    { 
      name: 'trainerId', 
      label: 'Assign Trainer', 
      type: 'select', 
      options: trainers.map(t => ({ label: t.fullName, value: t.id })),
      onQuickAdd: () => setShowQuickAddTrainer(true)
    },
  ];

  return (
    <>
      <CrudTable
        title="Groups"
        entityName="Group"
        columns={COLUMNS}
        formFields={FORM_FIELDS}
        fetchData={async () => {
          const res = await groupAPI.getAll();
          return res.data?.data || [];
        }}
        onAdd={(data) => groupAPI.add(data)}
        onUpdate={(id, data) => groupAPI.update(id, data)}
        onDelete={(id) => groupAPI.delete(id)}
      />

      {/* Quick Add Trainer Modal */}
      {showQuickAddTrainer && (
        <div style={overlayStyle} onClick={() => setShowQuickAddTrainer(false)}>
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ fontSize: '1.1rem', fontWeight: 700 }}>Quick Add Trainer</h3>
              <button onClick={() => setShowQuickAddTrainer(false)} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                <FiX />
              </button>
            </div>
            <form onSubmit={handleQuickAddTrainer} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div className="form-group">
                <label>Full Name</label>
                <input
                  className="form-input"
                  required
                  value={quickTrainerForm.fullName}
                  onChange={(e) => setQuickTrainerForm({ ...quickTrainerForm, fullName: e.target.value })}
                />
              </div>
              <div className="form-group">
                <label>Phone</label>
                <input
                  className="form-input"
                  required
                  value={quickTrainerForm.phone}
                  onChange={(e) => setQuickTrainerForm({ ...quickTrainerForm, phone: e.target.value })}
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={savingTrainer}>
                {savingTrainer ? 'Saving...' : 'Add Trainer'}
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.5)',
  backdropFilter: 'blur(4px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 3000,
};

const modalStyle = {
  background: '#fff',
  padding: 24,
  borderRadius: 16,
  width: '100%',
  maxWidth: 320,
};

export default GroupsAdmin;
